import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {computed} from "vue";
import ReactiveFilterableListRequest from "~/core-ui/ts/request/ReactiveFilterableListRequest";
import LcabApiRequestFactory from "~/cabinet/ts/api/LcabApiRequestFactory";
import MyRemoteDataCards from "~/cabinet/vue/interface/data/MyRemoteDataCards.vue";
import DataProviderLogCard
    from "~/operatorApplication/vue/dialogs/dialog/sidemenu/dataProvider/log/DataProviderLogCard.vue";



import {defineComponent} from 'vue';

const __default__ = defineComponent({
    name: "DataProviderLog"
});

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    platformId: {},
    authPrimaryId: {},
    entityTypeId: {},
    entityId: {},
    username: {}
  },
  setup(__props: any) {

let props = __props;

let request = computed(() => new ReactiveFilterableListRequest(LcabApiRequestFactory.create({
    url: '/api/events/dataProvider/operatorApplication/getEntityLog',
    p: {
        platformId: props.platformId,
        authPrimaryId: props.authPrimaryId,
        entityTypeId: props.entityTypeId,
        entityId: props.entityId,
        username: props.username
    }
})));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(MyRemoteDataCards, {
    "row-key": "id",
    request: _unref(request)
  }, {
    default: _withCtx(({item}) => [
      _createVNode(DataProviderLogCard, { log: item }, null, 8, ["log"])
    ]),
    _: 1
  }, 8, ["request"]))
}
}

})